import userRestService from '../services/user/UserRestService'
import userFunctions from '../services/user/UserUtilsFunctions'

const state = {
  users: [],
  filteredUsers: [],
  roles: [],
  dialogActived: false,
  userSavedSuccessfully: false,
  editedItem: {
    id: -1,
    username: '',
    version: null,
    roleIds: [],
    roles: [],
    active: true,
    company: {},
    password: '',
    passwordConfirmation: ''
  }
}

const getters = {
  getUsers: state => state.users,
  getRoles: state => state.roles,
  getRoleNameList: state => state.roles.map(role => role.displayName || role.name),
  isDialogActived: state => state.dialogActived,
  getEditedItem: state => state.editedItem,
  getFilteredUsers: state => state.filteredUsers,
  getUserSavedSuccessfully: state => state.userSavedSuccessfully
}
const actions = {
  async getUsers (context) {
    try {
      let data = await userRestService.getUsers()
      context.commit('setUsers', data)
    } catch (e) {
      console.log('Error fetching users')
    }
  },
  async getRoles (context) {
    try {
      let data = await userRestService.getRoles()
      context.commit('setRoles', data)
    } catch (e) {
      console.log('Error fetching roles')
    }
  },
  async saveUser (context, userInfo) {
    let snackBarContent = {actived: true, message: 'Usuario Agregado/Modificado Exitosamente.', color: 'success'}
    try {
      await userRestService.saveUser(userInfo)
      context.commit('setUserSavedSuccesfully')
    } catch (e) {
      snackBarContent = {actived: true, message: 'Error Agregando/Modificando usuario.', color: 'error'}
      context.commit('setSnackBarStatus', snackBarContent, {root: true})
      throw e
    }
    context.commit('setSnackBarStatus', snackBarContent, {root: true})
  },
  async disableUser (context, user) {
    let snackBarContent = {actived: true, message: 'Usuarui Agregado/Modificado Exitosamente.', color: 'success'}
    try {
      await userRestService.disableUser(user)
      context.commit('setUserSavedSuccesfully')
    } catch (e) {
      snackBarContent = {actived: true, message: 'Error Deshabilitando Usuario.', color: 'error'}
      context.commit('setSnackBarStatus', snackBarContent, {root: true})
      throw e
    }
    context.commit('setSnackBarStatus', snackBarContent, {root: true})
  },
  setDialogActived (context, active) {
    context.commit('setDialogActived', active)
  },
  setEditedItem (context, editedItem) {
    context.commit('setEditedItem', editedItem)
  },
  filterItems (context, filters) {
    context.commit('filterUsers', filters)
  },
  refreshFilteredusers (context) {
    context.commit('refreshFilteredusers')
  }
}
const mutations = {
  setUsers (state, users) {
    state.users = users
  },
  setRoles (state, roles) {
    state.roles = roles
  },
  setDialogActived (state, active) {
    state.dialogActived = active
  },
  setEditedItem (state, editedItem) {
    state.editedItem = editedItem
  },
  filterUsers (state, filters) {
    state.filteredUsers = userFunctions.filterUsers(state.users, filters)
  },
  refreshFilteredusers (state) {
    state.filteredUsers = state.users
  },
  setUserSavedSuccesfully (state) {
    state.userSavedSuccessfully = true
    setTimeout(function () {
      state.userSavedSuccessfully = false
    }, 4000)
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
